export default __webpack_public_path__ + "static/media/jan5.ce5f7037.jpg";